import React, { useState, useEffect } from "react";
import { Row, Col, Card, Table, Form } from "react-bootstrap";
import { Button } from 'primereact/button';
import axios from 'axios';
import config from '../config';
import { useAuth } from '../context/AuthContext';
import successVideo from '../assets/video/paperplane.mp4';
import crossVideo from '../assets/video/cross.mp4';
import { Dialog } from "primereact/dialog";

const VisualCreativeGuidelines = ({ brandId }) => {
    const { accessToken, role } = useAuth();
    const [visualCreativeGuidelines, setVisualCreativeGuidelines] = useState(null);
    const [loading, setLoading] = useState(true);
    const [submitLoading, setSubmitLoading] = useState(false); // New state for submit button
    const [editDialogVisible, setEditDialogVisible] = useState(false);
    const [videoDialogVisible, setVideoDialogVisible] = useState(false); // New state for video dialog
    const [videocrossDialogVisible, setVideocrossDialogVisible] = useState(false); // New state for video dialog
    const allowedRoles = [
        'Founder', 'Admin', 'SuperAdmin', 'HumanResource',
        'Social_Media_Manager', 'Task_manager'
    ];
    const fetchVisualCreativeGuidelines = async () => {
        try {
            const response = await axios.get(
                `${config.apiBASEURL}/BrandBookRoutes/brand-VisualAndCreativeGuidelines/${brandId}`,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );
            setVisualCreativeGuidelines(response.data);
        } catch (err) {
            console.error("Error fetching brand overview:", err);

        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        if (brandId) {
            fetchVisualCreativeGuidelines();
        }
    }, [brandId, accessToken]);

    const handleEditClick = () => {
        setEditDialogVisible(true);
    };

    const handleVisualAndCreativeGuidelinesChange = (e) => {
        const { name, value } = e.target;
        setVisualCreativeGuidelines((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async () => {
        setSubmitLoading(true); // Start loading
        try {
            const response = await axios.put(
                `${config.apiBASEURL}/BrandBookRoutes/brand-visualAndCreativeGuidelines/${visualCreativeGuidelines.visual_creative_guidelines_id}/${brandId}`,
                visualCreativeGuidelines,
                {
                    headers: { Authorization: `Bearer ${accessToken}` }
                }
            );

            if (response.status === 200) {
                setEditDialogVisible(false);
                setVideoDialogVisible(true);
                setTimeout(() => {
                    setVideoDialogVisible(false);
                    fetchVisualCreativeGuidelines();
                }, 5000);
            }
        } catch (error) {
            console.error("Error updating brand overview:", error);
            setVideocrossDialogVisible(true);
            setTimeout(() => {
                setVideocrossDialogVisible(false);
            }, 5000);
        } finally {
            setSubmitLoading(false); // Stop loading
        }
    };


    if (loading) return <p>Loading...</p>;
    return (
        <>
            <Card className="view-card">
                <Card.Header className="h6 border-0 bg-light d-flex justify-content-between align-items-center">
                    <div>
                        VisualCreativeGuidelines
                        <small className="text-danger d-block mt-1" style={{fontSize: '12px'}}>
                            Last Update: {visualCreativeGuidelines?.updatedAt ? new Date(visualCreativeGuidelines.updatedAt).toLocaleString('en-GB') : 'N/A'}
                        </small>
                    </div>
                    
                    <div className="d-flex align-items-center">
                    <small className="text-warning ">
                        {allowedRoles.includes(role) && (
                            <Button
                                title="Edit"
                                icon="pi pi-pencil"
                                className="p-0 border-0"
                                text
                                severity="help"
                                onClick={handleEditClick}
                            />
                        )}
                    </small>
                    </div>
                </Card.Header>
                <Card.Body className="p-0 pb-2 ">
                    <Table className="brandTable">
                        <tbody>
                            <tr>
                                <th className="text-start">Content Aesthetic<small className="d-block">(Describe the look & feel of visuals):</small></th>
                                <td>
                                    {visualCreativeGuidelines?.contentAesthetic}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Photography & Videography Guidelines<small className="d-block">(Filters, angles, tone, etc):</small></th>
                                <td>
                                    {visualCreativeGuidelines?.photographyVideographyGuidelines}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Graphic Design Style<small className="d-block">(Minimal, Illustrative, Bold, etc.):</small></th>
                                <td>
                                    {visualCreativeGuidelines?.graphicDesignStyle}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Do's & Don'ts for Creatives </th>
                                <td>
                                    {visualCreativeGuidelines?.dosAndDonts}
                                </td>
                            </tr>
                            <tr>
                                <th className="text-start">Templates & Editable Design Files <small className="d-block">(Link to drive folder):</small></th>
                                <td>
                                    {visualCreativeGuidelines?.templateDriveLink}
                                </td>
                            </tr>

                        </tbody>
                    </Table>
                </Card.Body>
            </Card>

            {/* Edit Dialog */}
            <Dialog
                header="Visual & Creative Guidelines"
                visible={editDialogVisible}
                style={{ width: '50vw' }}
                onHide={() => setEditDialogVisible(false)}
                footer={
                    <div>
                        <Button label="Cancel" icon="pi pi-times" severity="danger" onClick={() => setEditDialogVisible(false)} className="p-button-text py-2" />
                        <Button
                            label={submitLoading ? "Saving..." : "Save"}
                            icon={submitLoading ? "pi pi-spin pi-spinner" : "pi pi-check"}
                            severity="success"
                            onClick={handleSubmit}
                            disabled={submitLoading}
                            autoFocus
                            className="py-2"
                        />
                    </div>
                }
            >
                <Row className="mx-0" style={{ height: '70vh', overflowY: 'auto' }}>
                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Content Aesthetic <sub>(Describe the look & feel of visuals)</sub></Form.Label>
                        <Form.Control as="textarea" name="contentAesthetic" value={visualCreativeGuidelines.contentAesthetic} onChange={handleVisualAndCreativeGuidelinesChange} rows={4} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Photography & Videography Guidelines <sub>(Filters, angles, tone, etc.)</sub></Form.Label>
                        <Form.Control as="textarea" name="photographyVideographyGuidelines" value={visualCreativeGuidelines.photographyVideographyGuidelines} onChange={handleVisualAndCreativeGuidelinesChange} rows={4} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Graphic Design Style <sub>(Minimal, Illustrative, Bold, etc.)</sub></Form.Label>
                        <Form.Control as="textarea" name="graphicDesignStyle" value={visualCreativeGuidelines.graphicDesignStyle} onChange={handleVisualAndCreativeGuidelinesChange} rows={4} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Do's & Don'ts for Creatives</Form.Label>
                        <Form.Control as="textarea" name="dosAndDonts" value={visualCreativeGuidelines.dosAndDonts} onChange={handleVisualAndCreativeGuidelinesChange} rows={4} className="h-auto" />
                    </Col>

                    <Col md={12} lg={12} className="mb-3 px-1">
                        <Form.Label>Templates & Editable Design Files <sub>(Link to drive folder)</sub></Form.Label>
                        <Form.Control as="textarea" name="templateDriveLink" value={visualCreativeGuidelines.templateDriveLink} onChange={handleVisualAndCreativeGuidelinesChange} rows={4} className="h-auto" />
                    </Col>
                </Row>
            </Dialog>

            <Dialog visible={videoDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideoDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={successVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process Completed <span className='text-success'>Successfully</span></h6>
            </Dialog>


            <Dialog visible={videocrossDialogVisible} className='fadeInUp_dilog'
                onHide={() => setVideocrossDialogVisible(false)} style={{ width: '320px' }} closable={false}>
                <video src={crossVideo} autoPlay loop muted style={{ width: '100%' }} />
                <h6 className="text-center mt-0 fadeInUp">Process <span className='text-danger'>Denied</span></h6>
            </Dialog>

        </>
    );
};
export default VisualCreativeGuidelines
